// Filtre « À approuver (N) » de l'onglet Commandes.
export const DATA_MANAGER_ORDER_APPROVAL_VIEW_PENDING = "pending";

export function canOpenGeneralOrderEdit(canEditOrders, order) {
  return canEditOrders === true && (order?.is_editable !== false || order?.can_edit_coop === true) && order?.is_cancelled !== true;
}
